var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropiedades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #314D95;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 6.26,
    width: 62,
    height: 51.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1 6.26 1 57.74 33.12 57.74 33.12 26.6 44.02 26.75 44.02 6.26 1 6.26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_157",
    className: "cls-3",
    d: "M59.99,52.73h3.01v3.01H29.92v-3.01h3.01v-22.56c0-.83.67-1.51,1.51-1.51h15.04c.83,0,1.51.67,1.51,1.51v22.56h6v-12.03h-3.01v-3.01h4.52c.83,0,1.51.67,1.51,1.51v13.54ZM35.94,52.73h12.03v-21.05h-12.03v21.05ZM38.95,40.7h6.01v3.01h-6.01v-3.01ZM38.95,34.69h6.01v3.01h-6.01v-3.01Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    className: "cls-3",
    d: "M40.08,18.35v37.39H4.94V18.35L26.41,6.63v17.78l13.66-6.06ZM8.33,20.16v32.58h28.35v-28.89l-13.67,5.9V12.53l-14.68,7.63Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropiedades);
export default __webpack_public_path__ + "static/media/Propiedades.e2258b9739ae45ff3a630b80f1e1c51d.svg";
export { ForwardRef as ReactComponent };